export enum CarrierOperation {
  InterstateCarrier = "CRRINTER",
  IntrastateNonhazCarrier = "CRRINTRA",
  IntrastateHazmatCarrier = "CRRHMINTRA",
  InterstateShipper = "SHPINTER",
  IntrastateShipper = "SHPINTRA",
  VehicleRegistrant = "VEHICLE REGISTRANT",
}
